/* ==========================================================================
   FGO PDP v4 -- behaviours for the Beam-composition tea bag template.

   Ported from pdp/design/beam-v2-tea/index.html (22 Sep 2026). Three changes
   from the prototype, each because the prototype was a single static page and
   this is a Shopify template:

   1. ADD TO CART POSTS TO /cart/add.js. The prototype faked it with a label
      swap. Here the label swap stays as the confirmation, but only after the
      request succeeds -- a button that says "Added" when the cart did not
      change is worse than no feedback at all.
   2. THE FOOTER SENTINEL IS AN ELEMENT WE EMIT. The prototype watched .foot,
      which is its own footer. The theme footer is a different component, so
      the sticky bar watches a zero-height sentinel the template places.
   3. THE ACCENT SWITCHER IS GONE. It existed to demo three accent systems.
      Brand green won on 22 Sep, so there is nothing left to switch.

   Prices come from data- attributes Liquid writes, never from parsing money
   strings out of the DOM: the money format is a theme setting, and parsing it
   breaks the moment somebody changes it.
   ========================================================================== */
(function () {
  /* EVERY v4 SECTION EMITS ITS OWN .fgoP4 ROOT -- nine of them on a full page.
     This used to bind to the first one (the buy section) and query inside it,
     which silently hid every other section from this script: the Yotpo fetch
     never ran and the Origin and FAQ accordions never bound, because none of
     them live in the buy section. Queries therefore run against the document;
     `cfg` is kept only for the buy section's data- attributes. */
  var cfg = document.querySelector('.fgoP4[data-money]') || document.querySelector('.fgoP4');
  if (!document.querySelector('.fgoP4')) return;
  var root = cfg || document;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var attr = function (n, d) { return (cfg && cfg.getAttribute(n)) || d; };

  /* ---- gallery ---------------------------------------------------------- */
  var goToSlide = null;
  var slides = $('[data-p4-slides]');
  if (slides) {
    var slideEls = $$('.slide', slides),
        thumbs   = $$('.thumb'),
        dots     = $('[data-p4-dots]'),
        prev     = $('[data-p4-prev]'),
        next     = $('[data-p4-next]'),
        cur      = 0;
    if (dots) { slideEls.forEach(function () { dots.appendChild(document.createElement('i')); }); }
    var dotEls = dots ? $$('i', dots) : [];

    var setCur = function (i) {
      cur = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('on', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      dotEls.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (prev) prev.disabled = (i === 0);
      if (next) next.disabled = (i === slideEls.length - 1);
    };
    var go = function (i, instant) {
      i = Math.max(0, Math.min(slideEls.length - 1, i));
      slides.scrollTo({ left: slides.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
      setCur(i);
    };
    goToSlide = go;
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var tw = $('[data-p4-thumbs]');
    if (tw) {
      tw.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = Math.max(0, Math.min(thumbs.length - 1, cur + (e.key === 'ArrowRight' ? 1 : -1)));
          go(n); thumbs[n].focus();
        }
      });
    }
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    var st;
    slides.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { setCur(Math.round(slides.scrollLeft / slides.clientWidth)); }, 80);
    });
    slides.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(cur + 1);
      if (e.key === 'ArrowLeft') go(cur - 1);
    });
    setCur(0);

    var z = $('[data-p4-zdlg]'), zbtn = $('[data-p4-zoom]');
    if (z && zbtn) {
      zbtn.addEventListener('click', function () {
        var img = slideEls[cur].querySelector('img'), zi = $('[data-p4-zimg]', z);
        zi.src = img.currentSrc || img.src; zi.alt = img.alt;
        if (z.showModal) z.showModal(); else z.setAttribute('open', '');
      });
      $$('[data-close]', z).forEach(function (x) { x.addEventListener('click', function () { z.close(); }); });
      z.addEventListener('click', function (e) {
        if (e.target === z || e.target.classList.contains('modal')) z.close();
      });
    }
  }

  /* ---- price: variant x plan -------------------------------------------- */
  var FMT = attr('data-money', '${{amount}}');
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    if (FMT.indexOf('amount_no_decimals') > -1) v = String(Math.round(cents / 100));
    return FMT.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v);
  };
  var planEls = $$('input[name$="-plan"]');
  var currentVariant = function () {
    var v = $('input[name$="-size"]:checked');
    return v ? v : $('[data-p4-onlyvariant]');
  };
  var checkedPlan = function () {
    return planEls.filter(function (r) { return r.checked; })[0] || null;
  };
  var paint = function () {
    var v = currentVariant();
    if (!v) return;
    var full = parseInt(v.getAttribute('data-price'), 10),
        /* SALE (1 Oct 2026): the one-time price to charge, the sale price while the theme's sale runs
           (Liquid writes data-pay); the regular price is then the struck one beside Try Once */
        once = parseInt(v.getAttribute('data-pay'), 10) || full,
        sub  = parseInt(v.getAttribute('data-sub'), 10),
        cups = parseInt(v.getAttribute('data-cups'), 10) || 0,
        pe   = checkedPlan(),
        plan = pe ? pe.value : 'once';

    var set = function (sel, txt) { var e = $(sel); if (e) e.textContent = txt; };
    /* keep .is-picked on the checked row: the styling is on :has(), this is
       the same state for any browser that lacks it */
    $$('.fgoP4 .opt').forEach(function (o) {
      var i = o.querySelector('input[type="radio"]');
      o.classList.toggle('is-picked', !!(i && i.checked));
    });
    set('[data-p4-swval]', v.getAttribute('data-label') || '');
    set('[data-p4-serv]',  v.getAttribute('data-serv') || '');
    set('[data-p4-subcompare]', money(full));
    set('[data-p4-subprice]',   money(sub));
    set('[data-p4-onceprice]',  money(once));
    var oc = $('[data-p4-oncecompare]');
    if (oc) { oc.textContent = once < full ? money(full) : ''; oc.hidden = !(once < full); }
    if (cups) {
      set('[data-p4-subper]',  money(sub / cups) + ' per cup');
      set('[data-p4-onceper]', money(once / cups) + ' per cup');
    }
    set('[data-p4-planval]', plan === 'sub'
      ? attr('data-sublabel', 'Subscribe and Save')
      : 'Try Once');

    var pay = plan === 'sub' ? sub : once;
    set('[data-p4-stprice]', money(pay));
    var sc = $('[data-p4-stcompare]');
    if (sc) { sc.textContent = money(full); sc.style.display = (plan === 'sub' || once < full) ? '' : 'none'; }
    set('[data-p4-stsel]', (v.getAttribute('data-label') || '') + ' · ' +
      (plan === 'sub' ? 'Subscribe' : 'One time'));

    /* Picking a variant moves the gallery to that variant's own photograph,
       which is what the live PDP does. Only on a real change of variant: the
       first paint must not yank the gallery, and re-picking the same size
       should not scroll a shopper back to slide one. */
    var mi = parseInt(v.getAttribute('data-media'), 10);
    if (goToSlide && !isNaN(mi) && mi >= 0 && v !== lastVariant) {
      /* The first run syncs without animating. A product whose default variant
         is not the first image used to open showing another pack's photograph
         while that variant sat selected in the buy column -- the gallery and the
         selector disagreeing about what the shopper is looking at. Instant,
         because a page that scrolls its own gallery on load looks broken. */
      goToSlide(mi, lastVariant === null);
    }
    lastVariant = v;
  };
  var lastVariant = null;
  $$('input[name$="-size"],input[name$="-plan"]').forEach(function (r) {
    r.addEventListener('change', paint);
  });
  paint();

  /* ---- live Yotpo reviews ------------------------------------------------
     Nate: "can we pull in our yotpo reviews here like Beam does?"

     Fetched from the public widget API and built here rather than baked into
     the template, so the row is what Yotpo holds today. The verified badge is
     rendered per review from verified_buyer -- never stamped on the set.

     Everything Yotpo returns is escaped before it reaches the DOM. Review text
     is written by the public, so treating it as markup would be an injection
     hole with a queue of willing authors. */
  /* THE COUNT FOLLOWS THE WIDGET (23 Sep 2026). Nate: "it says 31 but yotpo
     shows 32". Three numbers existed for Elderberry: 31 in the product's yotpo
     metafield (what Liquid renders and the JSON-LD publishes -- Yotpo re-syncs
     it on its own schedule), 19/20/24 from the v1 widget API (it changed from
     call to call; that is why the gate below refuses to let it overwrite), and
     32 from the v3 storefront API -- the one the reviews widget itself reads,
     all 32 this product's own reviews (no grouping, no syndication). The page
     now paints the server's number and then takes v3's, so the headline, the
     buy column and "Read all N reviews" always agree with the widget they
     link to. If v3 fails, the server's number stands. */
  (function () {
    var src = document.querySelector("[data-p4-yotpo]");
    if (!src || !window.fetch) return;
    var key = src.getAttribute("data-p4-yotpo"), pid = src.getAttribute("data-p4-yotpo-product");
    if (!key || !pid) return;
    window.__p4v3 = fetch("https://api-cdn.yotpo.com/v3/storefront/store/" + encodeURIComponent(key) +
          "/product/" + encodeURIComponent(pid) + "/reviews?page=1&perPage=1",
          { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("yotpo v3 " + r.status); return r.json(); })
      .then(function (d) {
        var bl = d && d.bottomline;
        var n = bl ? parseInt(bl.totalReview, 10) : 0;
        if (!(n > 0)) return;
        var avg = Math.round((bl.averageScore || 0) * 10) / 10;
        var all = function (sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); };
        document.documentElement.setAttribute("data-p4-v3count", n);
        all("[data-p4-avgcount], [data-p4-buycount]", function (e) { e.textContent = n; });
        all("[data-p4-alllabel]", function (e) { e.textContent = "Read all " + n + " reviews"; });
        /* and the average and stars with it, so this path never waits on v1 */
        if (avg > 0) {
          all("[data-p4-avgnum], [data-p4-buyavg]", function (e) { e.textContent = avg.toFixed(1); });
          all("[data-p4-avgstars] .fill, [data-p4-buystars] .fill", function (e) { e.style.width = (avg * 20) + "%"; });
          var ast = document.querySelector("[data-p4-avgstars]");
          if (ast) ast.setAttribute("aria-label", avg.toFixed(1) + " out of 5 stars");
          all("[data-p4-avg], [data-p4-buyrating]", function (e) { e.hidden = false; });
        }
        var br = document.querySelector("[data-p4-buyrating]");
        if (br && avg > 0) br.setAttribute("aria-label", "Rated " + avg.toFixed(1) + " out of 5 stars from " + n + " reviews. Read the reviews.");
        return n;
      })
      .catch(function () { return 0; /* the server's count stands */ });
  }());

  var yp = document.querySelector("[data-p4-yotpo]");
  if (yp) {
    var esc = function (s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    };
    var starRow = function (score) {
      var s = '<span class="row o">', f = '<span class="row f">', i;
      for (i = 0; i < 5; i++) { s += '<svg><use href="#i-star"/></svg>'; f += '<svg><use href="#i-star"/></svg>'; }
      s += "</span>"; f += "</span>";
      return '<span class="stars" role="img" aria-label="' + score + ' out of 5 stars">' + s +
             '<span class="fill" style="width:' + (score * 20) + '%">' + f + "</span></span>";
    };
    var key  = yp.getAttribute("data-p4-yotpo");
    var pid  = yp.getAttribute("data-p4-yotpo-product");
    var want = parseInt(yp.getAttribute("data-p4-yotpo-count"), 10) || 6;
    var list = yp.querySelector("[data-p4-rscroll]");
    var url  = "https://api-cdn.yotpo.com/v1/widget/" + encodeURIComponent(key) +
               "/products/" + encodeURIComponent(pid) + "/reviews.json?per_page=" + want + "&page=1";

    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("yotpo " + r.status); return r.json(); })
      .then(function (d) {
        var resp = d.response || {};
        var bl   = resp.bottomline || {};
        var revs = resp.reviews || [];

        /* the average and the count come from the same payload as the cards, so
           the headline number cannot disagree with what is under it */
        var avgEl = document.querySelector("[data-p4-avg]");
        if (avgEl && bl.total_review > 0) {
          var avg = Math.round((bl.average_score || 0) * 10) / 10;
          var setT = function (sel, v) { var e = document.querySelector(sel); if (e) e.textContent = v; };
          setT("[data-p4-avgnum]", avg.toFixed(1));
          /* THE COUNT IS THE SERVER'S IF THE SERVER HAS ONE. It renders from
             the yotpo metafield, which is the same number this product's
             JSON-LD publishes -- overwriting it made the page paint 31 and
             then swap to 19, contradicting its own structured data in front
             of the shopper. The fetch still fills a count where there is
             none, which is what makes the sandbox demo work. */
          var keepCount = function (sel) {
            var e = document.querySelector(sel);
            /* a POSITIVE number only: a server '0' (no Yotpo sync yet) must
               not block a real count and paint '0 reviews' */
            return !!(e && parseInt((e.textContent || "").replace(/\D/g, ""), 10) > 0);
          };
          /* no server count: v1's number drifts between calls (19/20/24), so it
             only fills in if v3 comes back with nothing -- never a 20-then-32 flip */
          if (!keepCount("[data-p4-avgcount]") && !document.documentElement.hasAttribute("data-p4-v3count")) {
            var v1n = bl.total_review;
            (window.__p4v3 || Promise.resolve(0)).then(function (n3) {
              if (n3 > 0) return;
              setT("[data-p4-avgcount]", v1n);
              setT("[data-p4-alllabel]", "Read all " + v1n + " reviews");
            });
          }
          var st = document.querySelector("[data-p4-avgstars]");
          if (st) {
            var fill = st.querySelector(".fill");
            if (fill) fill.style.width = (avg * 20) + "%";
            st.setAttribute("aria-label", avg.toFixed(1) + " out of 5 stars");
          }
          var showAvg = function () { avgEl.hidden = false; };
          if (keepCount("[data-p4-avgcount]")) showAvg(); else (window.__p4v3 || Promise.resolve(0)).then(showAvg);
        }

        /* the same numbers fill the rating in the buy column, so the line above
           the fold and the carousel below can never disagree */
        if (bl.total_review > 0) {
          var br = document.querySelector('[data-p4-buyrating]');
          if (br) {
            var a2 = Math.round((bl.average_score || 0) * 10) / 10;
            var n2 = bl.total_review;
            var set2 = function (sel, v) { var e = document.querySelector(sel); if (e) e.textContent = v; };
            set2('[data-p4-buyavg]', a2.toFixed(1));
            /* same rule as the proof row above: the server's count wins */
            var bcEl = document.querySelector('[data-p4-buycount]');
            if (!(bcEl && parseInt((bcEl.textContent || '').replace(/\D/g, ''), 10) > 0) && !document.documentElement.hasAttribute('data-p4-v3count')) {
              (function (v1n) {
                (window.__p4v3 || Promise.resolve(0)).then(function (n3) { if (!(n3 > 0)) set2('[data-p4-buycount]', v1n); });
              }(n2));
            } else {
              n2 = parseInt((bcEl.textContent || '').replace(/\D/g, ''), 10) || n2;
            }
            var bs = document.querySelector('[data-p4-buystars] .fill');
            if (bs) bs.style.width = (a2 * 20) + '%';
            br.setAttribute('aria-label', 'Rated ' + a2.toFixed(1) + ' out of 5 stars from ' + n2 + ' reviews. Read the reviews.');
            var bcNow = document.querySelector('[data-p4-buycount]');
            if (bcNow && parseInt((bcNow.textContent || '').replace(/\D/g, ''), 10) > 0) br.hidden = false;
            else (window.__p4v3 || Promise.resolve(0)).then(function () { br.hidden = false; });
          }
        }

        /* only the LIVE row may have its cards replaced. The curated row's five
           were hand-picked -- several real reviews carry health claims, and one
           carries anti-vaccination content -- so the fetch fills its numbers and
           leaves its content alone. */
        if (yp.getAttribute('data-p4-yotpo-cards') !== '1') return;
        if (!list || !revs.length) return;
        list.innerHTML = revs.map(function (r) {
          var name = (r.user && r.user.display_name) || "Verified customer";
          var badge = r.verified_buyer
            ? '<p class="vbadge"><svg class="ico" aria-hidden="true"><use href="#i-check"/></svg>Verified customer</p>'
            : "";
          return '<li class="rcard">' + starRow(r.score || 5) +
                 (r.title ? '<p class="h5">' + esc(r.title) + "</p>" : "") +
                 "<blockquote><p>" + esc(r.content) + "</p></blockquote>" +
                 '<p class="who cap1 b">&mdash; ' + esc(name) + "</p>" + badge + "</li>";
        }).join("");
        window.dispatchEvent(new Event("resize"));
      })
      .catch(function () {
        /* a failed fetch leaves the row empty rather than showing an error to a
           shopper: missing social proof is a smaller problem than a broken page */
      });
  }
  /* ---- horizontal rows: reviews and related teas ------------------------ */
  var row = function (scrollSel, cardSel, prevSel, nextSel) {
    var rs = $(scrollSel);
    if (!rs) return;
    var p = $(prevSel), n = $(nextSel);
    var step = function () {
      var c = rs.querySelector(cardSel);
      return c ? c.getBoundingClientRect().width + 16 : 320;
    };
    var upd = function () {
      if (p) p.disabled = rs.scrollLeft < 4;
      if (n) n.disabled = rs.scrollLeft >= rs.scrollWidth - rs.clientWidth - 4;
    };
    if (p) p.addEventListener('click', function () { rs.scrollBy({ left: -step() }); });
    if (n) n.addEventListener('click', function () { rs.scrollBy({ left: step() }); });
    rs.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { rs.scrollBy({ left: step() }); e.preventDefault(); }
      if (e.key === 'ArrowLeft')  { rs.scrollBy({ left: -step() }); e.preventDefault(); }
    });
    rs.addEventListener('scroll', upd);
    window.addEventListener('resize', upd);
    upd();
  };
  row('[data-p4-rscroll]', '.rcard',   '[data-p4-rprev]',   '[data-p4-rnext]');
  row('[data-p4-relrow]',  '.relcard', '[data-p4-relprev]', '[data-p4-relnext]');

  /* ---- UGC clips play in place ------------------------------------------
     Nate: "the video player shouldn't click to load." It was an anchor to the
     raw .mp4, so a click left the page for the browser's bare file player.

     The poster is replaced by a <video> only on click, so nothing downloads
     until someone asks. playsinline keeps iOS from taking the clip fullscreen
     and dumping the shopper back on the page afterwards; muted lets autoplay
     actually start, and controls give them the volume back immediately.

     Starting one clip stops any other that is running: two customer videos
     talking over each other is nobody's idea of proof. */
  $$("[data-p4-video]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var pic = btn.querySelector(".p4UgcPic");
      if (!pic || pic.querySelector("video")) return;

      $$("video[data-p4-clip]").forEach(function (v) {
        v.pause();
        var host = v.parentNode;
        if (host && host.dataset.p4Poster) {
          host.innerHTML = host.dataset.p4Poster;
          delete host.dataset.p4Poster;
        }
      });

      pic.dataset.p4Poster = pic.innerHTML;
      var v = document.createElement("video");
      v.src = btn.getAttribute("data-p4-video");
      v.setAttribute("data-p4-clip", "");
      v.controls = true;
      v.autoplay = true;
      v.muted = true;
      v.playsInline = true;
      v.setAttribute("playsinline", "");
      v.preload = "auto";
      pic.innerHTML = "";
      pic.appendChild(v);
      var play = v.play();
      if (play && play.catch) { play["catch"](function () {}); }
    });
  });
  /* ---- accordions: one open per group ----------------------------------- */
  $$('[data-acc-group]').forEach(function (group) {
    var items = $$('[data-acc]', group);
    items.forEach(function (it) {
      var b = it.querySelector('.acc-btn');
      if (!b) return;
      b.addEventListener('click', function () {
        var was = it.classList.contains('open');
        items.forEach(function (o) {
          o.classList.remove('open');
          var ob = o.querySelector('.acc-btn');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        if (!was) { it.classList.add('open'); b.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  /* ---- sticky bar -------------------------------------------------------- */
  /* WHAT THE STICKY BAR HIDES AGAINST.

     It used to watch a sentinel we emit inside the FAQ section, which worked
     only while the FAQ was last. It is not any more -- the Yotpo widget moved
     below it -- so the bar would have hidden as soon as the FAQ appeared and
     stayed hidden through the whole review section. That is an ordering
     dependency that breaks silently every time a section moves.

     The theme's own <footer> is always last, by definition. Watch that, and
     keep the sentinel only as a fallback for a page that somehow has none. */
  var atc = $('[data-p4-atc]'), sticky = $('[data-p4-sticky]');
  var foot = document.querySelector('footer') || $('[data-p4-footsentinel]');
  if (atc && sticky) {
    var pastAtc = false, onFoot = false, mq = matchMedia('(max-width:1024px)');
    var stickyState = function () {
      var show = pastAtc && !onFoot;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.toggleAttribute('inert', !show);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        pastAtc = !e.isIntersecting && (mq.matches || e.boundingClientRect.top < 0);
        stickyState();
      }, { threshold: 0 }).observe(atc);
      if (foot) {
        new IntersectionObserver(function (en) {
          onFoot = en[0].isIntersecting; stickyState();
        }, { threshold: 0 }).observe(foot);
      }
    }
  }

  /* ---- add to cart ------------------------------------------------------- */
  /* The label only changes after the cart confirms. On failure the button says
     so rather than silently resetting: a shopper who saw nothing happen clicks
     again, and a second identical POST is a second line item. */
  var status = $('[data-p4-atcstatus]');
  $$('[data-p4-atc],[data-p4-statc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = currentVariant();
      if (!v) return;
      var pe = checkedPlan();
      var body = { items: [{ id: Number(v.getAttribute('data-vid')), quantity: 1 }] };
      /* the cadence select owns the plan id once the shopper picks one */
      var cadEl = document.querySelector('[data-p4-cadence]');
      if (pe && pe.value === 'sub' && cadEl && cadEl.value) {
        pe.setAttribute('data-planid', cadEl.value);
      }
      if (pe && pe.value === 'sub' && pe.getAttribute('data-planid')) {
        body.items[0].selling_plan = Number(pe.getAttribute('data-planid'));
      }
      var s = b.querySelector('span'), label = s ? s.textContent : '';
      b.disabled = true;
      if (s) s.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        if (s) s.textContent = 'Added';
        if (status) status.textContent = attr('data-title', 'Item') + ' added to cart';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          if (s) s.textContent = label;
          b.disabled = false;
          if (status) status.textContent = '';
        }, 1600);
      })['catch'](function () {
        if (s) s.textContent = 'Try again';
        if (status) status.textContent = 'That did not add to the cart. Please try again.';
        setTimeout(function () { if (s) s.textContent = label; b.disabled = false; }, 2200);
      });
    });
  });
})();
